import React, { useState } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { formatImageAlt } from "../../../shared/utils/stringUtilities";
import LayoutSlider from "../../templates/layout-slider/layoutSlider";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import "./gallery.scss";

const Gallery = (props) => {
  const [isModal, setIsModal] = useState(false);
  const [index, setIndex] = useState(-1);
  const [content, setContent] = useState();
  const [slider, setSlider] = useState<any>(null);
  const { isBrowser, document } = useBrowserMode();

  const imgs = props.referenciaContenidos;

  const showModal = (index: number) => {
    if (isBrowser) {
      const querySelector = document.querySelector("body");
      querySelector?.classList.add("freeze-page");
    }
    setIndex(index);
    setContent(imgs[index]);
    setIsModal(true);
  };

  const hideModal = () => {
    if (isBrowser) {
      const querySelector = document.querySelector("body");
      querySelector?.classList.remove("freeze-page");
    }
    setIndex(-1);
    setContent(undefined);
    setIsModal(false);
  };

  const next = () => {
    slider.slickGoTo(index);
    setContent(imgs[index + 1]);
    setIndex(index + 1);
  };

  const back = () => {
    slider.slickGoTo(index - 1);
    setContent(imgs[index - 1]);
    setIndex(index - 1);
  };

  return (
    <div className="o-gallery">
      {props.tituloGeneral && (
        <span
          className="o-gallery__title"
          dangerouslySetInnerHTML={{ __html: props.tituloGeneral }}
        ></span>
      )}
      <LayoutSlider
        widthRelative={true}
        customClass="o-gallery__layout-slider"
        sliderRef={setSlider}
      >
        {imgs &&
          imgs.map((value, index) => (
            <div
              className="o-gallery__container__cover"
              key={index}
              onClick={() => showModal(index)}
            >
              <img
                className="o-gallery__container__cover__img"
                src={value.imagenesPrincipal[0].file.url}
                alt={
                  value.imagenesPrincipal[0].title
                    ? formatImageAlt(value.imagenesPrincipal[0].title)
                    : `Imagen ${props.tituloGeneral}`
                }
              />
            </div>
          ))}
      </LayoutSlider>
      {isModal && (
        <div className="o-gallery__modal">
          <div className="o-gallery__modal__background" onClick={hideModal} />
          <div className="o-gallery__modal__container">
            <div className="o-gallery__modal__container__top">
              <span className="o-gallery__modal__container__top__label">
                {index + 1}/{imgs.length}
              </span>
              <button
                className="o-gallery__modal__container__top__button"
                onClick={hideModal}
              >
                Cerrar
              </button>
            </div>
            <div className="o-gallery__modal__container__cover">
              <img
                className="o-gallery__modal__container__cover__img"
                src={content?.imagenesPrincipal[0].file.url}
                alt={
                  content?.imagenesPrincipal[0].title
                    ? formatImageAlt(content?.imagenesPrincipal[0].title)
                    : `Imagen ${props.tituloGeneral}`
                }
              />
              <button
                hidden={index === 0}
                className="o-gallery__modal__container__cover__back"
                onClick={back}
              />
              <button
                hidden={index >= imgs.length - 1}
                className="o-gallery__modal__container__cover__next"
                onClick={next}
              />
            </div>
            {content?.descripcion && (
              <div className="o-gallery__modal__container__text">
                {documentToReactComponents(content?.descripcion.json)}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
